import { useMemo } from 'react';
import { makeBizRound, toleranceText } from './biz';
import type { DrillProps } from './meta';
import { NumberDrill } from './NumberDrill';

export function BizDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeBizRound(level, seed), [level, seed]);
  return (
    <NumberDrill
      questions={questions} seed={seed} onDone={onDone} className="biz-drill"
      info={(q) => ({ key: q.key, lines: q.lines, answer: q.answer })}
      render={(q) => (
        <div className="biz-card">
          <div className="biz-shop">{q.shop}</div>
          <ul className="biz-lines">{q.lines.map((l, i) => <li key={i}>{l}</li>)}</ul>
          <p className="biz-ask">{q.ask}</p>
          <p className="small muted biz-tol">{toleranceText(q, q.unit)}</p>
        </div>
      )}
    />
  );
}
